<template>
    <div>
        <common-content-wrapper class="company-details" width="gigantic">
            <common-content-spacer height="medium">
                <public-profile-header
                    :ratings="companyRatings"
                    :numberOfRatings="companyAvgRating[0].numberOfRatings"
                    :averageRating="companyAvgRating[0].averageRating ? companyAvgRating[0].averageRating : 0"
                    :title="company.name"
                    :company="company"
                    :showFavorites="false"
                    :isCompanyProfile="true"
                    :shareTitle="company.name"
                    :shareDescription="getTranslation(company?.descriptionTextContent)"
                    :buttonLabel="$t('pages.user.user_profile.tabs.offers')"
                    @action-click="goToOfferTab()"
                ></public-profile-header>

                <image-slideshow v-if="slideImages.length" :images="slideImages"></image-slideshow>

                <div v-if="companyUsers.length" class="company-details__container">
                    <div class="company-details__description">
                        <div v-if="company?.descriptionTextContent?.originalText" class="company-details__title">
                            {{ $t('common.microcopy.description') }}
                        </div>
                        <div v-if="company?.descriptionTextContent?.originalText">
                            {{ getTranslation(company?.descriptionTextContent) }}
                        </div>
                    </div>
                    <meet-the-team v-if="companyUsers" class="company-details__users" :users="companyUsers"></meet-the-team>
                </div>

                <user-ratings
                    v-if="companyAvgRating[0].numberOfRatings"
                    :numberOfRatings="companyAvgRating[0].numberOfRatings"
                    :averageRating="companyAvgRating[0].averageRating ? companyAvgRating[0].averageRating : 0"
                    :ratings="companyRatings"
                ></user-ratings>

                <contact-us-segment :markers="userMarkers" :locations="locations"></contact-us-segment>
            </common-content-spacer>
        </common-content-wrapper>
    </div>
</template>

<script>
    import PublicProfileHeader from 'components/page-elements/common/PublicProfileHeader'
    import UserRatings from 'components/page-elements/rating/UserRatings'
    import ContactUsSegment from 'components/page-elements/common/ContactUsSegment'
    import ImageSlideshow from 'components/page-elements/images/ImageSlideshow'
    import MeetTheTeam from 'components/page-elements/common/MeetTheTeam'
    import PhotoTypeEnum from 'enums/photo_type.enum'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [TranslateMixin],

        components: { PublicProfileHeader, UserRatings, ContactUsSegment, ImageSlideshow, MeetTheTeam },

        props: {
            company: { type: Object, required: true },
            companyAvgRating: { type: Array, default: () => new Array() },
            companyRatings: { type: Array, default: () => new Array() },
            companyUsers: { type: Array, default: () => new Array() },
        },

        data: () => ({
            PhotoTypeEnum: PhotoTypeEnum,
        }),

        computed: {
            userMarkers() {
                return this.company.locationsForCompany?.map((location) => ({
                    averageRating: this.companyAvgRating[0].averageRating,
                    numberOfRatings: this.companyAvgRating[0].numberOfRatings,
                    isCompanyOffer: true,
                    providerData: this.company,
                    coordinates: { lat: location.latitude, lng: location.longitude },
                    locationType: location.locationType,
                }))
            },

            slideImages() {
                return this.company.photos.filter((item) => item.type === PhotoTypeEnum.COMPANY_OTHER)
            },

            locations() {
                return this.company.locationsForCompany?.map((location) => ({
                    id: location.id,
                    address: location.address,
                    timeZone: location.timeZone,
                    location: location.location,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    emails: location.emails,
                    telephones: location.telephones,
                    facebook: this.company.facebook,
                    instagram: this.company.instagram,
                    twitter: this.company.twitter,
                    tiktok: this.company.tiktok,
                    linkedin: this.company.linkedIn,
                    city: { name: location.city?.name },
                    companyServiceProvider: this.company,
                    locationType: location.locationType,
                }))
            },
        },

        methods: {
            goToOfferTab() {
                this.emitEvent({ name: 'go-to-offer-tab' })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/company/_company-details.scss';
</style>
